import { render, staticRenderFns } from "./waitMe.vue?vue&type=template&id=ffccd5a2&scoped=true&"
import script from "./waitMe.vue?vue&type=script&lang=js&"
export * from "./waitMe.vue?vue&type=script&lang=js&"
import style0 from "./waitMe.vue?vue&type=style&index=0&id=ffccd5a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffccd5a2",
  null
  
)

export default component.exports